export default {
  "+wet4N": "인증 코드 오류",
  "2QzYmY": "취소",
  "32AbcK": "회사 선택",
  "4R5GEq": "홈",
  "9Kfib+": "알 수 없는 오류",
  "9UZxwP": "인증 코드를 입력하세요",
  "9cYMNA": "회사 정보",
  "9ljNkr": "재전송",
  "9vpYSL": "회사 삭제",
  "EWMpn/": "역할 삭제",
  FEb7U2: "확인",
  "J3BW/8": "이메일로 받은 인증 코드를 입력하세요",
  "QK/hAI": "권한 보기",
  TqDOFU: "인증 코드를 자주 보내지 마세요!",
  XeiAal: "삭제",
  aiBGBs: "삭제 성공",
  azDNha: "성공적으로 전송되었습니다",
  "e/6XZC": "인증 코드를 받지 못하셨나요?",
  jNxbTC: "인증 코드는 비워둘 수 없습니다.",
  l1fZNE: "모든 상자를 선택 취소할 수 없습니다",
  "2MYr1m": "로그인",
  "lzP/we": "다운로드",
  m0Qdyj: "확인 실패",
  nJCPaY: "사용자는 바인딩된 이메일 주소가 없어 확인할 수 없습니다.",
  x79O39: "삭제하시겠습니까?",
  xxETOY: "회사 데이터 권한 구성",
  yGWx2z: "매개변수 오류",
  Unvxiq: "계정 전환",
  ggvI6Z: "모두 선택",
  lKbhpS: "장치 그레이스케일 업데이트 가능 기간(현지 시간)",
  ayUfs1: "종료 시간은 시작 시간보다 이전일 수 없습니다.",
  "03eM6t": "200개 항목/페이지",
  "7/cUwn": "장치 업데이트 가능 기간(현지 시간)",
  SGDlQ6: "총 {total}개 항목",
  "arp+TQ": "50개 항목/페이지",
  e8OyHO: "20개 항목/페이지",
  iyOrrD: "100개 항목/페이지",
  yXsHgv: "10개 항목/페이지",
  "+/R6RX": "작업 상태",
  "+0SHNk": "Wi-Fi MAC 주소",
  "+4lD9e": "이름",
  "+74JfZ": "예: Device_000001_Gaoqiao Store_Android",
  "+7V2pl": "흔한",
  "+CLSks": "2. 이 명명 규칙이 적용되는 장치 시스템 유형",
  "+GQdfc": "업데이트토큰",
  "+L9lak": "알람 템플릿 적용",
  "+TzicH": "가게",
  "+gbx50": "경보상태",
  "+kHAfa": "매장정보를 입력해주세요",
  "+m8vFq": "명명 규칙 세부정보",
  "/8GfsH": "4개",
  "/99v4N": "모든 매장",
  "/CxA3j": "하위 매장 추가",
  "/Qlgz9": "Windows 장치 업로드",
  "/SqqyP": "장치 일련번호를 입력하세요",
  "/cqdKk": "다운로드",
  "/sI6h+": "사람들",
  "0KH9Qi": "장치 시스템 유형",
  "0VK6Tv": "사업현황",
  "0YYUNG": "{num}개의 태그가 선택되었습니다.",
  "0iTEVO": "토큰 보기",
  "0uRy1k": "하나",
  "11uVJ/": "객체 수신",
  "19+woq": "매장 세부정보",
  "1M03Dq": "일정 템플릿",
  "1PtjRr": "장치 이름",
  "1SslIM": "앱 닫기",
  "1X8SYs": "위도와 경도",
  "1sAivX": "이더넷 MAC 주소",
  "1sj5Sj": "이 장치에 적용된 모든 일정 템플릿을 제거합니다.",
  "2/LdaO": "매장 구성 정보",
  "2JW1Pt": "동시에 이메일을 보낼지 여부를 선택하세요",
  "2nV3tA": "선택한 매장이 없습니다.",
  "2opnVU": "실행 중",
  "2qrsN7": "매장주소를 선택해주세요",
  "2r/XUW": "이 태그가 적용된 모든 일정 템플릿 삭제",
  "3HzQUc": "JSON 내보내기",
  "3QXG/d": "오라 버전",
  "3XHWMy": "목요일",
  "3aYG4L":
    "현재 장치에 적용되어 있는 알람 템플릿을 제거하고 더 이상 알람을 모니터링 및 전송하지 않습니다.",
  "3h+3Xm": "영업하지 않음",
  "3jyOjJ": '선택한 장치를 "등록됨"으로 수정할지 여부',
  "3qF993": "현재 회사에 속하지 않은 기기는 이전할 수 없습니다.",
  "4/e9qs": "이름을 입력해주세요",
  "4Xdib8": "기간은 비워둘 수 없습니다.",
  "4c3uw8": "매장 밖으로 이동",
  "4vWL+W": "기기 가져오기",
  "4wi+/p": "주형",
  "5+oaTO": "이미지 마지막 업데이트 상태",
  "5Cm9U3": "메시지 알림",
  "5Hy0Qx": "동일 매장으로 이전 불가",
  "5KtG4i": "업체 검색",
  "5WKL9+": "매장상태 선택",
  "5jpkHg": "온라인 상태",
  "5p8cBO": "계정 관리",
  "5ytYaf": "새 일정 템플릿 추가",
  "6+iYA0": "일련번호",
  "60Ixlm": "알람 템플릿 이름",
  "6eB+xj": "특정 사용자를 선택하세요.",
  "6pDRb2": "유효한 비밀번호를 입력하세요.",
  "7ip592": "1. 명명 규칙 이름",
  "88CuCZ":
    "3. 본 매장에 등록된 장비에 대한 네이밍 방식을 설정합니다. (장비명 자동입력)",
  "8PESa6": "장애를 입히다",
  "8huAxo": "새 규칙 추가",
  "8u3CYe": "명명 규칙 이름",
  "8usMqO": "공지사항 삭제",
  "8zN+hZ": "애플리케이션 실행",
  "9/Vb7e": "장치 업로드",
  "919TK9": "지원되는 형식: xls, xlsx",
  "9AsSO/": "문자 메시지 동시 발송 여부를 선택해 주세요",
  "9UefLp": "상표",
  "9g6s9o": "상점코드를 입력해주세요",
  "9iKk2b": "시작 번호",
  "9r00YD": "공지사항 관리",
  "9w+ho+": "계정",
  "9yRpjk": "토요일",
  "A/eXwT": "이 라벨에 적용된 모든 경보 템플릿을 제거합니다.",
  A5kf1W: "모든 회사 목록",
  ANeFu6: "비밀번호 확인",
  Abqe2U: "매장 주소",
  Axagls: "종료시간을 선택해주세요",
  AyWMlZ: "예약된 작업 추가",
  B57Wbu: "선택한 기기가 없습니다.",
  BBpRbn: "이 스토어에 적용된 모든 알람 템플릿 제거",
  BC74I9: "프롬프트 메시지",
  BQcLxf: "아래로 이동",
  BYbqwY: "파일을 여기로 드래그하거나 업로드를 클릭하세요.",
  BwXapw: "카테고리 이름은 500자 이내로 조절해주세요",
  C6cGK1: "일정 템플릿 이름은 비워둘 수 없습니다.",
  CLqPBU: "편집하다",
  CPTAAj: "자연수의 증가",
  D5HOUz: "상태 선택",
  DADacD: "이 매장에 적용된 모든 일정 템플릿을 삭제하세요.",
  DFyP1k: "매장 닫기",
  DxGUhN: "모든 기기 선택",
  E1GPl7: "소유자",
  EGvInA: "장치 알람 목록",
  EM8lAi: "자사 장비별 업데이트 가능 기간(현지시각)",
  "EO+Nlk": "파일을 업로드하는 중입니다. 대화 상자를 닫지 마십시오.",
  EwM8Kj: "정말 이사하고 싶으신가요?",
  Ey9rBq: "삭제하시겠습니까?",
  F2LJDJ: "정말로 제거하시겠습니까?",
  F3ndvv: "삭제 실패",
  FBH89G: "수정된 버전",
  FNIJXx: "스크롤 플레이를 선택해주세요",
  "FaJ/jI": "가져올 파일을 선택하지 않았습니다.",
  FbCeo1: "트리거 값",
  FbsCUK: "휴대폰",
  "Fr1I/b": "상표",
  Ft60hS: "누비스 장비",
  G4XFn6: "하드웨어 모델",
  G4qgGm: "모든 사용자",
  G5gg2V: "공지사항 제목이 필요합니다.",
  G6i1QR: "주소 선택",
  G9APSK: "명명 규칙 편집",
  Gk0Mt5:
    "정말로 ({name}) 알람 장치를 재설정하시겠습니까? 경보 규칙은 재설정 후에도 계속 모니터링됩니다.",
  GnzEo7: "이미지 마지막 업데이트 시간",
  GujK99:
    "추후 알람 템플릿의 내용이 업데이트되면 해당 디바이스에도 동기화됩니다.",
  Gwj7xc: "기본값 복원",
  H5s58g: "24시간",
  HN1dNJ: "모든 계정",
  HOHQFs: "명명 규칙 이름은 비워둘 수 없습니다.",
  HRXYJB: "모든 기업",
  "HdxQ2/": "스토어 관련 구성 파일 및 명명 규칙",
  "Hv/pfB": "화요일",
  I37xbU: "작성해주세요",
  ITbo35: "상점 이름은 비워둘 수 없습니다!",
  IqkgWZ: "키워드",
  "Iwt/8W": "주석",
  "J0D5h+": "시작 시간",
  J9jPRL: "성공적으로 복사되었습니다",
  JJl2M9: "내보내다",
  JLMIof: "Android 기기 업로드",
  JRhVym: "영업시간은 비워둘 수 없습니다.",
  JeJAmT: "이름 바꾸기",
  Jh62y5: "모든 기기",
  Jp7u8z: "탑",
  KJHvMA: "매장관리",
  KlWMzW: "활성화됨",
  Km733q: "시작 시간을 선택하세요.",
  Kwqd8h: "담당자",
  L24ioQ: "제목",
  L80hmc: "공지사항 제목은 30자를 초과할 수 없습니다.",
  LNGTru: "장치 예약 실패 목록",
  LWSLHa: "친절한 팁",
  Lfia0v: "일정 설정",
  "LuP+H0": "설명하다",
  LwhdsE: "다중 선택 전환",
  M404r0: "둘",
  MZ5Ei7: "기간이 {num}번째 기간과 겹칩니다.",
  MmsEyp: "등록하다",
  MnTdIi: "트리거 수",
  N52KMq: "상세주소",
  NGs9sO: "반품",
  "NM/lRq": "업로드 취소",
  NjB2tN: "업종을 선택해주세요!",
  OMcnk6: "제조업체",
  OSqnZu: "선택한 장치 버전을 다음으로 변경할지 여부",
  "OZGX3+": "공지사항 목록",
  OaZpDP: "UUID",
  OcijhH: "마더보드 일련 번호",
  OsMncl: "켜지지 않음",
  "P/eul9": "아니요",
  PVmkgT: "닉네임을 입력해주세요",
  PaMvre: "알람 규칙 목록",
  PnYplH: "장비",
  PrIueu: "24시간 영업",
  "Py/5UG": "운영 중인 노드가 더 이상 존재하지 않습니다. 다시 운영해 주세요.",
  "Q+0CDu": "명명 규칙 추가",
  "Q2/NzC": "{num}개의 기기가 선택되었습니다.",
  QHc9Qg: "공지사항",
  QHhMxE: "역할 선택",
  QLYuf8: "모든 기업",
  QV3pnn: "상태",
  QpOtgZ: "매장명",
  Qpcx6F: "공지사항 내용은 필수입니다.",
  Qpi3DY: "낮",
  "QsAe0/": "저장 실패",
  QwHI8Q: "쿼리 결과:",
  R2D5Dv: "생성 시간",
  RCjVsb: "장치 ID",
  RNaGVr: "작업 실패 목록",
  RQyKsa: "플랫폼 발표",
  RWBRyt: "장비분포도 작성중",
  RndUeh: "예상 실행 시간",
  RyXQqJ: "업로드 시간",
  S1QSWC: "하위 매장으로 가져오기",
  S57QRB: "필터링 기준",
  SbZhau: "부팅 작업에서는 부팅 장치를 지정해야 합니다.",
  SkK50H: "예약된 작업을 추가하세요",
  SwMBFl: "일정 템플릿 적용",
  T3CtvK: "카테고리 이름은 비워둘 수 없습니다.",
  TDSTTj: "일정 템플릿 선택",
  TDuPUp: "트리거됨",
  TLZPhr: "월요일",
  TYAJpp: "{num}개의 매장이 선택되었습니다.",
  UA7mv6: "오라 마지막 업데이트 시간",
  UBbWUL: "선택한 템플릿이 없습니다.",
  UZ49sl: "담당자 전화번호",
  UtE0dS: "작동하다",
  "Uu/nFu": "이 장치에 적용된 모든 알람 템플릿 제거",
  V0RiZp: "작업 성공",
  Vd3wZV: "전반적인",
  Ve9Ksw: "매장 이전",
  ViVQNi: "역할",
  VqEr9u: "신청 매장 수",
  Vx4M25: "상점 코드",
  "W/wIZ8": "담당자",
  WYHxWn: "삼",
  WYtW9Y: "버전을 선택하세요.",
  WdyIyo: "운행시간",
  WtPk7v: "동시에 SMS 보내기",
  WxPZOH: "{num}번 실행",
  WypzMq: "예약된 작업",
  Wzv7kF: "매장을 선택해주세요",
  X2PYza: "장치 세부정보",
  "XKj/en": "BIOS 일련번호",
  "XLdI1+": "Wi-Fi 강도",
  XMBOec: "태그 제거",
  XPFi6q: "조각",
  XmRKnc: "주목",
  YYGRyG: "첨부파일을 업로드해주세요",
  YeF1dY: "시간대",
  YpXN8m: "마지막 트리거 시간",
  YwEzx2: "표시해야 하는 필드를 확인하세요.",
  ZGYHyC: "시작 시간은 비워둘 수 없습니다.",
  ZQ91U9: "집",
  ZUPzqr: "켜다",
  ZdO12B: "매장에 신청하기",
  "Zvt+2g": "창고",
  aBleoN: "알람 템플릿 선택",
  aGxRt2: "콘텐츠",
  "aN+DgN": "활성화 시간",
  akvGrq: "규칙 구성",
  askOz5: "주소 검색",
  "b+Dz+s": "전체 매장 목록",
  b5l2vN: "구하다",
  bBz42a: "업데이트 상태",
  "bE+h3K": "장치 상태",
  bFBjSK: "다섯",
  bOKDVF: "라디오 전환",
  biXcnk: "담당자 이메일",
  bqbDVw: "질문",
  bzfrYI: "공지사항 구성",
  cDZ00w: "확인하다",
  "cZ9/ZC": "[{name}]을(를) 삭제하시겠습니까?",
  cawvIS: "마지막 업데이트",
  cgIBtg: "상위 레벨 선택",
  cr1ymH: "발송시간을 선택해주세요",
  "d7i/AT": "상위 레이어",
  dEXfrL: "장치 상태 간격",
  dGBGbt: "모두",
  drCsUI: "회사",
  eAgY2G: "자회사 확장",
  eCCa0L: "작업 유형",
  "eP/37G": "등록 시간",
  eeCxuz: "운영체제 유형",
  evJP5c: "명명 규칙",
  f7Dpbl: "템플릿을 다운로드하고 템플릿 프롬프트에 따라 콘텐츠를 개선하세요.",
  "fc12+X": "금요일",
  fz2pkM: "노드가 삭제되었습니다.",
  gU4eZD: "알람 관리",
  gmUXEi: "장비 특성값",
  gnNjS5: "개인 장치 이름",
  gpg5DN: "공지사항 보기",
  gplM71: "일일",
  "gyh+d1": "유선 네트워크",
  "h/j3a5": "연락 전화번호",
  h7w4pz: "아직 데이터가 없습니다",
  "hD7/Lu": "보여주다",
  "hDx3/S": "우편",
  hEI4G8: "새로운 발표",
  hYN7oM: "숨다",
  hkJXyi: "예약된 작업 구성",
  i5MLJc: "마지막 업데이트: {lastUpdate}",
  "i6kDf/":
    "선택한 장치에 {num}개의 Nubis Free 버전이 포함되어 있으면 장치 명령을 사용할 수 없습니다.",
  iKomBu: "아직 분류가 없습니다.",
  iN7Lps: "사이클 모드",
  ich0wH: "장치SN",
  ifGp4v: "2FA",
  "j/YGZ0": "지도",
  j3QWSE: "자연수 증가의 시작 숫자는 양의 정수만 될 수 있습니다.",
  j6m8Si: "연락처 이메일",
  jAAXdQ: "장비점",
  jT6zKT: "장치 수",
  "jhfb/7": "성공적으로 저장되었습니다",
  js3tZs: "일정 템플릿 이름",
  k7dy8j: "관련 구성 파일",
  k9dozc: "실행 시간",
  kG2Etz: "온라인",
  khyRcw: "엑셀 파일을 선택해주세요",
  "kr+7Iy": "매장 검색",
  l36W55: "스크롤 플레이",
  lK6HPZ: "매장상태를 선택해주세요",
  lVgYx7: "정지된",
  lllhRf: "종료 시간은 비워둘 수 없습니다.",
  loTFGc: "이름 없음",
  m1h20o: "추후 일정 템플릿의 내용이 업데이트되면 해당 기기에도 동기화됩니다.",
  mFIXSq: "장치 일련번호",
  mKKd1R: "수신자를 선택하세요.",
  "mYa6W/": "맞춤 텍스트",
  ma6S6y: "맞춤 디스플레이",
  mn0ceu: "중복된 구성 규칙이 있습니다. 조정하세요.",
  "mpeFt+": "경보 규칙",
  nGubXb: "일정 템플릿 세부정보",
  nUSeQB: "선택한 계정이 없습니다.",
  nzsNwZ: "장치 상태",
  "o+O5d1": "과제를 선택해주세요",
  o5OLcm: "매장 약어",
  o8tJYm: "장치 명령",
  o9lryN: "일요일",
  "oFt+cN": "네트워크 속도 테스트",
  oW4Uka: "양수인",
  obfTaf: "매장 구성",
  ojz0Ke: "더 보기 >",
  oru5FY: "일정 템플릿 수정",
  "p/3Nn5": "모바일 네트워크",
  pBPyFt: "누비스 버전",
  pK94Zd: "매장으로 가져오기",
  "pV2t/S": "기본정보",
  pXEyon: "장치 유형",
  peNVzr: "{num}주마다",
  peUIwk: "공지사항 작성",
  pfGGi0:
    "현재 장치에 적용되어 있는 스케줄 템플릿을 제거하고 더 이상 실행하지 않습니다.",
  pielKO: "부팅 장치",
  q6qKtH: "쿼리 조건:",
  q9PHLT: "아직 발표가 없습니다",
  q9YGIf: "사업",
  qDba8m: "오프라인 장치 상태",
  qUKj7E: "복사",
  qUiH5y: "구성 규칙은 비워둘 수 없습니다.",
  "qqwM/t": "구성 파일",
  qyh9hz: "영업시간",
  "r0/TUu": "확신하는",
  "r2dEd/": "다시 놓기",
  rAKRwm: "기기 버전 선택",
  rDRAr0: "운영 체제 버전",
  s1l1Jq: "매장 및 계정 관리",
  s7NSze: "작업을 확인하기 전에 계정 비밀번호를 입력하세요.",
  s9U9qn: "알람 설정",
  sGYTej: "나머지",
  sOIerB: "활성화되지 않음",
  sVsXUO: "수요일",
  sZSyGZ: "~할 수 있게 하다",
  srEpKw: "업로드 중",
  srpWCM: "표시해야 할 필드를 확인하고 드래그하여 정렬하세요.",
  t5gffJ: "장비정보",
  tugHWJ: "공지사항 목록으로 돌아가기",
  u3dVQz: "주간",
  ubuOXs: "등기",
  ujBeLh: "유지관리 시스템 고시",
  "uoZwj+": "창조자",
  uuRzdk: "매장에 속해있습니다",
  v04auv: "종료 시간",
  vD5wnY:
    "속하고 싶은 매장을 확인하세요. 즉, 해당 매장의 권한이 있다는 의미입니다.",
  vDCwZ9: "파일 업로드",
  vr5TVT: "입력해주세요",
  wOHHSJ: "위로 이동",
  wQAiLI: "알림 재설정",
  wYygRu: "보내는 사람",
  "wrU/Kc": "{num}일마다",
  x34QXR: "종료 시간은 시작 시간보다 이전일 수 없습니다.",
  xI0mPJ: "이미 켜져 있음",
  xISm1t: "활성화",
  xUjLTE: "찾다",
  xXdMar: "사용자 지정",
  xuf2rG: "모든 매장",
  xx40g7: "공지사항 제목",
  "y+WxsP": "편집상의 공지",
  yKFvYY: "동시에 이메일 보내기",
  yOMNOj: "예",
  yReEcE: "라벨 선택",
  yb3AuG: "오프라인",
  ybGQQ3: "관련 검색결과 없음",
  yc6ZUL: "Ora 마지막 업데이트 상태",
  ydktLD: "구분 기호",
  yeCGlM: "육",
  yfhtRM: "충수",
  ygAHaf: "보내는 시간",
  yy7EDI: "업로드",
  zftpop: "사용자 선택",
  znuEgQ: "영업시간 추가",
  zok1hp: "C 슬롯",
  zvaxmN: "일정관리",
  zyMKgy: "매장 선택",
  o5QBKU: "회사 업데이트 성공",
  "1yM7WW": "선택한 장치를 제거하시겠습니까?",
  DqB8kg: "장치 제거",
  QH21BX: "장치 일괄 등록",
  TlDh4N: "장치를 일괄 삭제",
  UcumBq: "경보 알림",
  X9zJwr: "일괄적으로 장치 할당",
  lkP6UV: "장치 업데이트",
  wLyMu9: "템플릿 프롬프트에 따라 콘텐츠를 개선하세요",
  FQM81K: "선택한 매장 상태를",
  WqfGVu: "30단어로 제한됨",
  hV5chR: "창을 팝업할지 선택해주세요",
  vD7UHb: "팝업 창",
  "0Drg5o": "위의 약관에 동의합니다",
  "7pY6K/": "이용 약관",
  CNkomH: "편집 약관",
  CoaQps: "약관 관리",
  "HHA/d7": "용어 목록",
  UH1kCc: "추가",
  "VzqtN+": "이용약관이 필요합니다",
  hOtsIx: "새로운 기사",
  ilUpPP: "용어 목록 반환",
  "j+y4w+": "용어 제목이 필요합니다",
  j4CmNU: "약관 보기",
  jJg298: "기사 제목",
  t4lrWD: "기사 제목은 30자를 넘을 수 없습니다",
  z7A1Fc: "약관 만들기",
  "OY+bYK": "확인, 다시 표시하지 마세요",
  "+d1f6p": "Linux 기기 업로드",
  UrM0bR: "인증 정보",
  "+uAolt": "예: 사용자가 개인화된 웹 경험을 위해 웹사이트 제목, 아이콘, 텍스트를 쉽게 사용자 지정할 수 있도록 합니다.",
  "0UAhKu": "예: https://nubiscloud.freshdesk.com/support/home",
  "0h3ZUE": "계정 센터 업로드",
  "0lEh3g": "Nubis 공간 업로드",
  "0xMj0V": "예: 새 버전 제공 또는 기기 이미지 업데이트",
  "3DMdxJ": "DeviceCenter 탭 편집",
  "4ImW13": "예: 스토어 관리",
  "52LsQF": "예: 계정 센터",
  "5BTra1": "예: 플랫폼",
  "61gplm": "텍스트 업로드",
  "6sZvzw": "기기 센터 키워드 바꾸기",
  "7bKyxU": "업로드된 이미지는 Nubis 드라이브 파일 브라우저에 저장됩니다. 파일 손상 또는 삭제 시 이미지 로딩에 실패합니다.",
  "7q8OJE": "플랫폼 편집",
  "8TfVSD": "플랫폼 탭 편집",
  "8pToBN": "예: Cloud",
  "9/8z30": "사용자가 개인화된 웹 경험을 위해 웹사이트 제목, 아이콘 및 텍스트를 쉽게 사용자 지정할 수 있도록 허용",
  "9C+wuW": "예: 기기 관리",
  "D1cAYC": "예: 기기 센터",
  "FKBH20": "예: Nubis Space",
  "G+eQYn": "예: 매장 및 계정 관리",
  "G2LkOf": "공지 관리 업로드",
  "I9uxGU": "예: 글로벌 서비스, 상상력을 창조하고, 지능형 경험을 제공",
  "K1Xqdl": "예: 권한 관리",
  "LTVlAP": "업그레이드 센터에 업로드",
  "Q1/SUP": "예: 유지 관리 시스템 공개 알림",
  "QAN35o": "예: 기기 관리, 모니터링, 원격 제어 등",
  "R8nCNR": "기기 관리에 업로드",
  "TVuUjT": "Ora",
  "U08bUN": "기기 센터에 업로드",
  "Wu2nnZ": "플랫폼 소개",
  "ZP1/uy": "예: Nubis 플랫폼 역할 권한 관리",
  "ayjmy+": "예: 전 세계 기기 및 그룹 관리",
  "bhXvJB": "권한 관리 업로드",
  "cAIDk5": "지원 센터",
  "d3b8dv": "맞춤형 관리 업로드",
  "dFHONh": "Nubis",
  "dWy8l5": "예: Ora",
  "fZJ9SZ": "예: 파트너 및 클라이언트",
  "jAmQmn": "예: 개발 센터",
  "kwx95y": "예: 개인 맞춤 관리",
  "ov96O9": "개인 맞춤 관리",
  "rM4ciX": "예: 공지 관리",
  "uDYj3x": "웹사이트 센터",
  "uRrPru": "매장 관리 업로드",
  "vdUVb9": "예: 업그레이드 센터",
  "xrKftB": "아이콘 업로드",
  "2IaM+V": "업데이트 센터",
  "EoXhnk": "기기 센터",
  "JeSd9K": "기타",
  "wzIKok": "상위 회사의 개인 설정값을 상속받습니다",
  "BQDKvZ": "예시: 에이전트",
  "EO9pTF": "예시: 클라우드",
  "/NrLZv": "라이선스 수량",
  "1Dklb3": "자동 적용 날짜",
  "1dyq46": "CMS",
  "1t0NXU": "결제일",
  "2DbIoa": "주문 세부 정보",
  "2hUF5M": "라이선스를 1개 이상 선택하세요",
  "2qqw4C": "영업 담당자",
  "3Y6eOz": "만료됨",
  "5FboZ/": "유형",
  "6bBRd8": "고객 이메일",
  "6jMfox": "주문 기록 수신됨",
  "D0cpCO": "라이선스 수량",
  "EBMdAL": "생성됨",
  "FDRhoz": "전송됨",
  "G0UYbD": "라이선스 선택",
  "GCrD1e": "남은 기간",
  "JeSd9K": "기타", "JmnNA0": "선택 필드",
  "LG70v2": "주문 기록 전송",
  "NZQWZL": "공식",
  "PjtWQX": "선택된 {num}개 라이선스",
  "Plhuph": "주문 번호, ERP 번호 검색",
  "Rrwy85": "생성자",
  "TX6jKq": "수신자",
  "U+pKlD": "주문 번호: {name}을(를) 삭제하시겠습니까?",
  "Xvn+2E": "고객 연락처",
  "YII2+w": "만료일",
  "YJbxtM": "수신 회사",
  "ZIJmYm": "주문 관리",
  "ZTs8/J": "라이선스 생성",
  "a7AYs5": "유효 기간(일)",
  "eM8o1Y": "주문 번호",
  "eUSpdN": "더 보기",
  "er7lkB": "금액", "fyjje7": "라이선스 키",
  "gqvOsW": "고객 담당자", "iTiIWl": "일치하는 데이터를 찾을 수 없습니다",
  "k1xuGk": "주문 번호 검색",
  "kPb1Wj": "ERP 번호",
  "lfUbAE": "활성",
  "mPsm6o": "테스트 중",
  "ouraCD": "기기 관리",
  "pUL1dA": "주문 삭제",
  "pecEGk": "취소",
  "sTreBL": "실제 유효 날짜",
  "sbThvA": "회사 전송",
  "svGx//": "유효한 번호를 입력하세요",
  "tMGiGt": "라이선스 유형",
  "tsV2n0": "주문 생성",
  "twizE+": "영업 담당자 이메일",
  "u6rHwS": "주문 생성일",
  "vePxOp": "정상", "wNYTXq": "사용되지 않음",
  "wawZXM": "라이선스 상태",
  "xVTk70": "로딩 중",
  "xxFsds": "필수 입력란",
  "0axARa": "만료일",
"0tqhdw": "관리자 이상 직급의 사용자는 [{x}]개 회사, 총 [{y}]개 회사로부터 이메일을 받게 됩니다.",
"4DfIa5": "선택한 라이선스 유형은 베타 버전이 아니어야 합니다.",
"4kc3eS": "매월 1일에 시스템에서 알림이 필요한 라이선스 또는 장치 상태에 대한 이메일을 발송합니다. 이메일에는 다음 정보가 포함됩니다.",
"7FTqlN": "일치하는 라이선스가 없습니다.",
"AfMAI0": "라이선스를 보유한 장치는 현재 라이선스가 만료되면 자동으로 새 라이선스를 받게 됩니다.",
"FQjcoc": "라이선스 자동화 규칙",
"GDWKlf": "페어링된 장치 일련 번호",
"Iqlkbs": "선택한 라이선스 상태는 미사용이어야 합니다.",
"K5iYC8": "향후 100일 이내에 자동 활성화될 예정인 미사용 라이선스입니다.",
"NBz0wZ": "현재 활성화되어 있지만 어떤 장치에도 할당되지 않은 라이선스입니다.",
"URkpah": "만료된 라이선스입니다.", 
"UjxKxu": "종료됨",
"VaAWfW": "자동 만료일이 가까운 라이선스일수록 우선순위가 높습니다.",
"Wp2PXY": "알림 설정",
"X2YceA": "미사용 라이선스",
"ZLqStU": "사전 가져온 기기는 등록 시 자동으로 라이선스를 받습니다.",
"daUauj": "라이선스 키, 주문 번호, 페어링된 기기 일련번호",
"eFFkgE": "라이선스 재고 개요",
"eHMGvf": "라이선스를 선택하세요.",
"eR85km": "승인된 라이선스가 향후 100일 이내에 만료되는 기기입니다. 라이선스가 만료되고 대체 라이선스가 제공되지 않으면 해당 기기는 예약 상태로 전환됩니다.",
"fTfy0b": "시스템이 라이선스 자동화 규칙에 따라 라이선스를 자동으로 적용합니다.",
"ftSBnR": "페어링된 라이선스",
"lLC16+": "라이선스 관리",
"lQGDqR": "기기가 이미 예약 또는 일시 중지 상태입니다.",
"lTtEaU": "예약됨", "t0EXqz": "유효한 라이선스",
"vPHZLC": "자회사 포함",
"xy6tQS": "OR 코드 또는 API를 통해 등록된 기기는 자동으로 라이선스가 부여됩니다.",
"zE041n": "만료일",
"FQQECq": "필수",
"ekxzlF": "이름"
};
